export const ApiConstants = {
  INVITE_CODE: 'inviteCode',
} as const;
